
const digest = 'b496f792fd29fd862b0f4b37904304e61e652755d505540a0e0da87f27feab7e';
const classes = {"wrapper":"_wrapper_1a6j4_1"};
const css = `._wrapper_1a6j4_1 {
  border: 1px solid #e2e5ed;
  height: 100%;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  